export default __webpack_public_path__ + "static/media/fullScreen.8e2df14e.svg";